import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { BodyM, BrandM } from '@sorare/core/src/atoms/typography';
import { TextureBackground } from '@sorare/core/src/atoms/ui/TextureBackground';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';

import {
  TutorialStepAsset,
  TutorialStepContent,
  TutorialStepTextContent,
} from '../ui';
import wheelImage from './assets/wheel.webp';

const StyledTextureBackground = styled(TextureBackground)`
  position: absolute;
  inset: 0;
  z-index: -1;
`;

const Title = styled(BrandM)`
  white-space: nowrap;
`;

const Img = styled.img`
  mask-image: linear-gradient(to right, black 50%, transparent 100%);
  margin-left: calc(-1 * var(--triple-unit));
  width: 120%;
`;

export const WheelStep = () => {
  return (
    <Bezel borderColor="var(--c-nd-150)">
      <StyledTextureBackground
        background="wave2"
        mode="dark"
        color={['transparent', 'var(--c-blue-400)']}
        imageOpacity={0.3}
        withDots
      />
      <TutorialStepContent>
        <TutorialStepAsset>
          <Img src={wheelImage} alt="wheel" />
        </TutorialStepAsset>
        <TutorialStepTextContent>
          <Title>
            <FormattedMessage
              id="WheelStep.title"
              defaultMessage="Spin the Wheel"
            />
          </Title>
          <BodyM color="var(--c-nd-600)">
            <FormattedMessage
              id="WheelStep.subtitle"
              defaultMessage="Spin the wheel to win rewards"
            />
          </BodyM>
        </TutorialStepTextContent>
      </TutorialStepContent>
    </Bezel>
  );
};
